let select2 = require('select2')
global.cityMatcher = function (params, data) {
    // Always return the object if there is nothing to compare
    if ($.trim(params.term) === '') {
        return data;
    }

    // Do a recursive check for options with children
    if (data.children && data.children.length > 0) {
        // Clone the data object if there are children
        // This is required as we modify the object to remove any non-matches
        var match = $.extend(true, {}, data);

        // Check each child of the option
        for (var c = data.children.length - 1; c >= 0; c--) {
            var child = data.children[c];

            var matches = matcher(params, child);

            // If there wasn't a match, remove the object in the array
            if (matches == null) {
                match.children.splice(c, 1);
            }
        }

        // If any children matched, return the new object
        if (match.children.length > 0) {
            return match;
        }

        // If there were no matching children, check just the plain object
        return matcher(params, match);
    }

    var original = data.text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    var term = params.term.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

    let rgx = new RegExp('^' + term)

    if (rgx.test(original)) {
        return data;
    }

    // If it doesn't contain the term, don't return anything
    return null;
}

global.applicationProjectMatcher = function (params, data) {
    // If there are no search terms, return all of the data
    if ($.trim(params.term) === '') {
        return data;
    }

    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
        return null;
    }

    // `params.term` should be the term that is used for searching
    // `data.text` is the text that is displayed for the data object
    if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
        return data;
    }
    if (
        data.element.dataset.jar_code
        && data.element.dataset.jar_code.toLowerCase().indexOf(params.term.toLowerCase()) > -1
    ) {
        //var modifiedData = $.extend({}, data, true);
        return data;
    }

    // Return `null` if the term should not be displayed
    return null;
}

require('/Framework/assets/js/cms-select2');
